import BaseService from "./base.service";

export type CategoryDetails = {
    id: string;
    title: string;
}

export type Category = CategoryDetails & {
    index: number;
    icon: string;
    templateType: string;
    responseStatus: number;
    unreadMessagesCount: number;
    messages: Message[]
}

export type Message = {
    index: number;
    id: string;
    date: Date;
    isRead: boolean;
    content: MessageContent;
    category: CategoryDetails;
}

export type MessageContent = {
    title: string;
    summary: string;
    media: string;
    callToActionTitle: string;
    details: MessageDetails;
    mobileDetails: MessageDetails;
}

export type MessageDetails = {
    title: string;
    media: string;
    content: string
    callToAction: CallToAction;
}

export type CallToAction = {
    title: string;
    link: string;
}

class InboxService extends BaseService {
    constructor() {
        super();
        this.setBaseUrl("inbox");
    }

    async getInboxAsync() {
        const customerNumber = this.customerNumber.toString();
        return this.createPromiseRequest(customerNumber).get<Category[]>();
    }

    async markAsRead(categoryId: string, messageId: string) {
        const customerNumber = this.customerNumber.toString();

        const request = {
            categoryId,
            messageId,
            customerNumber
        };

        return this.createPromiseRequest("").put(request);
    }

    async delete(categoryId: string, messageId: string) {
        const customerNumber = this.customerNumber.toString();
        
        const request = {
            categoryId,
            messageId,
            customerNumber
        };

        return this.createPromiseRequest("").delete(request);
    }
}

export default InboxService;